function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m0.44624 20.09c0-10.778 8.7498-19.527 19.527-19.527 10.815 0 19.527 8.7498 19.527 19.527 0 10.815-8.7123 19.527-19.527 19.527-10.778 0-19.527-8.7123-19.527-19.527z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m0.44624 20.09c0-10.778 8.7498-19.527 19.527-19.527 10.815 0 19.527 8.7498 19.527 19.527 0 10.815-8.7123 19.527-19.527 19.527-10.778 0-19.527-8.7123-19.527-19.527",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 9
});
var _ref4 = /*#__PURE__*/React.createElement("rect", {
  className: "icon-tertiary",
  x: 22.518,
  y: 4.4929,
  width: 5,
  height: 14,
  fill: "#adb9ca",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});
var _ref5 = /*#__PURE__*/React.createElement("g", {
  className: "icon-tertiary",
  fill: "#fff",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, React.createElement("rect", {
  x: 6.5185,
  y: 10.493,
  width: 5,
  height: 8
}), React.createElement("rect", {
  x: 14.518,
  y: 8.4929,
  width: 5,
  height: 10
}), React.createElement("rect", {
  x: 6.5185,
  y: 20.493,
  width: 21,
  height: 3
}));
var _ref6 = /*#__PURE__*/React.createElement("g", {
  strokeMiterlimit: 10
}, React.createElement("g", null, React.createElement("path", {
  className: "icon-tertiary",
  d: "m14.913 21.281c0-1.3563 1.1129-2.4558 2.4863-2.4558h11.603c1.3734 0 2.4863 1.0995 2.4863 2.4558v9.8234c0 1.3563-1.1129 2.4558-2.4863 2.4558h-11.603c-1.3734 0-2.4863-1.0995-2.4863-2.4558z",
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  className: "icon-primary",
  d: "m17.395 18.825h11.612c1.371 0 2.4816 1.0731 2.4816 2.3971v2.7484h-16.575v-2.7484c0-1.3241 1.1105-2.3971 2.4816-2.3971z",
  fill: "#ecaec6",
  fillRule: "evenodd"
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m17.395 18.825h11.612c1.371 0 2.4816 1.0731 2.4816 2.3971v2.7484h-16.575v-2.7484c0-1.3241 1.1105-2.3971 2.4816-2.3971z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), React.createElement("path", {
  className: "icon-tertiary",
  d: "m11.534 19.197c0-1.368 1.1357-2.477 2.5371-2.477h11.84c1.4015 0 2.5371 1.109 2.5371 2.477v9.9081c0 1.368-1.1357 2.477-2.5371 2.477h-11.84c-1.4015 0-2.5371-1.109-2.5371-2.477z",
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  className: "icon-primary",
  d: "m14.079 16.72h11.612c1.371 0 2.4815 1.122 2.4815 2.5061v2.8733h-16.575v-2.8733c0-1.3842 1.1105-2.5061 2.4815-2.5061z",
  fill: "#ecaec6",
  fillRule: "evenodd"
}));
var _ref7 = /*#__PURE__*/React.createElement("g", {
  className: "icon-secondary",
  fill: "#adb9ca",
  strokeMiterlimit: 10
}, React.createElement("rect", {
  x: 14.425,
  y: 23.632,
  width: 2.1311,
  height: 2.105
}), React.createElement("rect", {
  x: 14.531,
  y: 27.522,
  width: 2.1311,
  height: 2.105
}));
var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m14.528 18.931c0-0.18774 0.14575-0.34001 0.32307-0.34001h10.285c0.17732 0 0.32307 0.15228 0.32307 0.34001v1.3606c0 0.18774-0.14575 0.34001-0.32307 0.34001h-10.285c-0.17732 0-0.32307-0.15228-0.32307-0.34001z",
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m14.084 16.72h11.835c1.3973 0 2.5291 1.1352 2.5291 2.5357v2.9073h-16.893v-2.9073c0-1.4005 1.1318-2.5357 2.5291-2.5357z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});
var _ref0 = /*#__PURE__*/React.createElement("g", {
  className: "icon-tertiary",
  stroke: "#002060"
}, React.createElement("path", {
  d: "m19.009 24.653h6.9522",
  fill: "#e2f0d9",
  fillRule: "evenodd",
  strokeMiterlimit: 8
}), React.createElement("path", {
  d: "m19.073 28.649h6.9098",
  fill: "#e2f0d9",
  fillRule: "evenodd",
  strokeMiterlimit: 8
}), React.createElement("rect", {
  x: 14.51,
  y: 23.674,
  width: 2.0463,
  height: 1.9991,
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}), React.createElement("rect", {
  x: 14.531,
  y: 27.67,
  width: 1.9828,
  height: 1.9779,
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}));
var SvgMenuPulseQuestions = function SvgMenuPulseQuestions(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref0);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenuPulseQuestions, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-pulse-questions.ede9d2ba.svg";
export { ForwardRef as ReactComponent };